<template>
    <component :is="appSection"
            :categoryId="categoryId" :familyId="familyId" :languageId="languageId"
            :searchTerm="searchTerm" :accountId="accountId" :accountUserId="accountUserId"
            :ordersListLite="ordersListLite" :gtagActionField="gtagActionField" />
</template>

<script lang="ts" src="./App.vue.ts"></script>